jQuery(document).ready(function($){

  const topLevelMenuItemWithChildren = $('.menu-item-has-children>a');

  /**
   * Disables top-level menu items from being click-able if they have children
   */
  $(topLevelMenuItemWithChildren).on('click',function(e){
    e.preventDefault();
  });
});


// WEBPACK FOOTER //
// ./assets/js/header.js